<div><p class="mb-1" v-if="loading"><slot>Loading data from the server</slot></p><progress class="progress is-primary" v-if="loading"></progress></div>